import React, { Component } from 'react';
import {connect} from 'react-redux';

import {
	fetchPackages,
	getRetailPackageList,
} from '../../actions/retailActions';
import SinglePackage from "../SinglePackage/SinglePackage";
import {VIEWS} from "../../helpers/constants";

class PackagesList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			packs: [],
			loading: false
		}
	}

	componentDidMount() {
		this.setState({
			loading: true
		}, async () => {
			await this.props.getPackagesList();
			this.getPackageData();
		});
	}

	componentDidUpdate(prevProps) {
		if (this.props.filter !== prevProps.filter) {
			this.getPackageData();
		}
		if (this.props.packages !== prevProps.packages) {
			this.getPackageData();
		}
	}

	getPackageData = () => {
		const {packages} = this.props;
		Promise.all(packages.map( async item  => {
			const appsList = await this.props.getRetailPackageList({
				packageId: item.id,
				filter: this.props.filter,
			});
			return {
				...item,
				retailMarketItems: appsList,
				total: appsList.totalElements
			}
		})).then( res => {
			this.setState({
				packs: res,
				loading: false
			})
		}).catch(error => {
			console.error(error);
			return [];
		});
	};

	render() {
		const {loading, packs} = this.state;
		const filteredPacks = this.props.globalView === VIEWS.PACKAGE_ONLY ? packs : packs.filter(pack => pack.total !== 0);
		const renderList = filteredPacks.map(pack =>
			<SinglePackage
				key={pack.id}
				packageItem={{
					...pack
				}}
				showApp={this.props.showApp}
				remove={this.props.remove}
				showAttributes={this.props.showAttributes}
				globalView={this.props.globalView}
				filter={this.props.filter}
			/>
		);

		if (loading) {
			return <div className="localmarket-loading">Loading...</div>
		}

		return (
			<div>
				{renderList}
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getRetailPackageList: (query) => dispatch(getRetailPackageList(query)),
		getPackagesList: query => dispatch(fetchPackages(query)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	packages: state.packagesList.packages,
	packagesLoading: state.packagesList.loading,
	packageApps: state.retailPackageAppsList.packageApps,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PackagesList)



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/PackagesList.js